import { Filmomtale, ICustomImage } from "@filmweb/sanity-types";
import classNames from "classnames";
import { CMSPicture, CMSPictureSource } from "components/images/Image";
import { ITopItem } from "lib/types/Frontpage";
import { DocumentType_MOVIE, FwPakkeImageDocument, IMovieArticle, getUrl } from "lib/types/sanity";
import Link from "next/link";
import { useMemo } from "react";
import styles from "./HeroArticle.module.css";

//#region [Props]
type HeroArticleProps = {
    topItem?: ITopItem;
    movies?: Filmomtale[];
    allowTitleOverride?: boolean;
};
//#endregion

//#region [Component]
export default function HeroArticle({ topItem, movies, allowTitleOverride }: HeroArticleProps) {
    const filmomtale = useMemo<Filmomtale | undefined>(() => {
        if ((movies?.length ?? 0) > 0 && topItem) {
            if (topItem.document?._type === DocumentType_MOVIE) {
                const edi = (topItem.document as IMovieArticle).edi.current;
                return movies!.find(m => m.mainVersionEDI === edi);
            }
        }
    }, [topItem, movies]);

    if (!topItem?.document) {
        return null;
    }

    //const isFilmwebImage = !!filmomtale?.mainImage || !!filmomtale?.images?.[0];
    let isFilmwebImage = false;
    let image: FwPakkeImageDocument | ICustomImage | undefined = (topItem.document.frontpageImage as FwPakkeImageDocument ?? topItem.document.image as FwPakkeImageDocument);
    if (!image) {
        isFilmwebImage = true;
        image = (filmomtale?.mainImageV2) ?? (filmomtale?.imagesV2?.[0]);
    }

    let title: string = filmomtale?.title ?? topItem.document.title;
    if (allowTitleOverride && topItem.document.titleOverride) {
        title = topItem.document.titleOverride as string;
    }

    const url = getUrl(topItem.document);
    if (!url) {
        return null;
    }

    const altText = isFilmwebImage ? `Bilde fra '${filmomtale?.title}'` : ((image as FwPakkeImageDocument)?.altText ?? (image as FwPakkeImageDocument)?.title);

    return (
        <article className={styles.SArticle}>
            <Link href={url} passHref legacyBehavior>
                <a className={styles.SArticleLink}>
                    {image && <CMSPicture className={styles.STopImage} isFilmweb={isFilmwebImage} image={image} fallbackWidth={640} fallbackHeightRatio={1.43} altText={altText ?? ""}>
                        <CMSPictureSource media="(min-width: 641px)" sizes={[1440]} heightRatio={0.5} />
                    </CMSPicture>
                    }
                    <header className={classNames(styles.SArticleHeader, !!image && styles.SArticleHeader_hasImage )} >
                        <div>
                            <h1 className={styles.SArticleTitle}>{title}</h1>
                            {topItem.subtitle && <p className={styles.SArticleSubTitle}>{topItem.subtitle}</p>}
                        </div>
                    </header>
                </a>
            </Link>
        </article >
    );
}
//#endregion
